import { useMutation } from "@tanstack/react-query";
import { api } from "../lib/api";

export const useSuggestImagePrompt = () =>
  useMutation({
    mutationFn: (draftId: string) => api.images.suggestPrompt(draftId),
  });
